import { InfoOutlined } from "@mui/icons-material";
import { styled } from "@mui/material";

const InfoIcon = styled(InfoOutlined)({
  opacity: 0.4,
  fontSize: 20,
  transition: "opacity .25s",
  "&:hover": { cursor: "pointer", opacity: 0.8 },
});

export default InfoIcon;
